__turbopack_context__.v({
  "active": "PinnedHorizontalCarousel-module__HIN_iq__active",
  "item": "PinnedHorizontalCarousel-module__HIN_iq__item",
  "itemImageWrapper": "PinnedHorizontalCarousel-module__HIN_iq__itemImageWrapper",
});
